module.exports = __webpack_public_path__ + "static/media/reducao_icon.0c1f86f9.JPG";